import Vue from "vue";
import "./plugins/axios";
import "@/assets/less/common.less";
import "@cmbi/cmbi-ui/dist/cmbi.css";
import App from "./App.vue";
import router from "./routers";
import "@/components/icons";
import store from "./store";
import "@/lib/sensor.js";
import i18n from "./i18n/index";
import { initMixin } from './plugins/initMixin';
import {cmbiToast} from "@cmbi/cmbi-ui";
import comp from '@/components';
import utils from '@/utils/util';
import '@vant/touch-emulator';

initMixin();
// Vue.config.productionTip = false;
// 引用公共js
Vue.prototype.utils = utils;

Vue.use(cmbiToast);
Vue.use(comp);
new Vue({
	router,
	i18n,
	store,
	render: h => h(App)
}).$mount("#app", true);
